import React, { FC } from 'react'
import App from './App'
import { Provider } from 'react-redux'

import store, { persistor } from './Store'
import { PersistGate } from 'redux-persist/integration/react'
import {Routes, Route} from 'react-router-dom'
import {AccessTokenLogin} from './AccessTokenLogin'

const AppWrapper: FC = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
      <Routes>
          <Route path='/access/:accessToken' element={<AccessTokenLogin />} />
          <Route path='*' element={<App />} />
        </Routes>
      </PersistGate>
    </Provider>
  )
}

export default AppWrapper
